import FileSystemObjectModel from '@/model/FileSystemObjectModel';
import Directory from '@/model/Directory';

class File extends FileSystemObjectModel
{
	public directory: Directory;
	public realName: string;
	public publicPath: string;
	public mimeType: string;
	public size: number;

	public constructor(options: any)
	{
		super(options);

		this.realName = options.realName;
		this.publicPath = options.publicPath;
		this.mimeType = options.mimeType;
		this.size = options.size;
	}

	get displaySize(): string
	{
		let i = 0;
		const sizes = ['B', 'KB', 'MB', 'GB'];
		let displaySize = this.size;

		while (displaySize > 1000)
		{
			displaySize /= 1000;
			i++;
		}

		return (displaySize) ? displaySize.toFixed(2) + ' ' + sizes[i] : '';
	}
}

export default File;